import React, { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { PaymentRequestButtonElement } from '@stripe/react-stripe-js'
import { useStripeWithHandling } from 'hooks/useStripeWithHandling'
import { getPaymentRequestConfigByCurrencySymbol } from 'constants/currency'

const GoogleApplePay = ({ priceData, productId, email, processTransaction }) => {
  const stripe = useStripeWithHandling()
  const [paymentRequest, setPaymentRequest] = useState(null)

  useEffect(() => {
    setPaymentRequest(null)
    if (stripe) {
      const paymentRequestConfig = getPaymentRequestConfigByCurrencySymbol(priceData?.symbol)
      const localizedStripePriceId = priceData?.stripe?.priceId

      const pr = stripe.paymentRequest({
        country: paymentRequestConfig.country,
        currency: paymentRequestConfig.currency,
        total: {
          label: 'Tiiny Host Subscription',
          amount: Math.round((priceData?.value || 0) * 100)
        },
        requestPayerName: true,
        requestPayerEmail: false
      })

      pr.on('paymentmethod', async (res) => {
        const { paymentMethod, payerName: name } = res

        if (paymentMethod) {
          processTransaction(
            {
              name,
              email,
              priceId: localizedStripePriceId,
              paymentGateway: 'STRIPE',
              productId
            },
            paymentMethod.id
          )
          res.complete('success')
        } else {
          res.complete('fail')
        }
      })

      // Check the availability of the Payment Request API.
      // The .catch() silences cross-origin rejections in non-HTTPS environments (e.g. local dev).
      pr.canMakePayment()
        .then((result) => {
          if (result) {
            setPaymentRequest(pr)
          }
        })
        .catch(() => {
          // Payment Request API unavailable — button simply won't render
        })
    }
  }, [stripe, priceData, email, productId, processTransaction])

  return paymentRequest ? (
    <Row className="mb-3 tr-apple-google-pay">
      <Col>
        <PaymentRequestButtonElement options={{ paymentRequest }} />
      </Col>
    </Row>
  ) : null
}

export default GoogleApplePay
